import React from 'react';
import { useSelector } from 'react-redux';
import Login from './components/Login';
import HomePage from './components/HomePage';
import UpdateNotification from './components/UpdateNotification';

export default function App() {
    const authData = useSelector(state => state.auth.authData);
    return (
        <>
            <UpdateNotification />
            {authData ? <HomePage /> : <Login />}
        </>
    );
}